import styled from "styled-components";
import { STYLES } from "../../Constant/Theme";


export const Title = styled.div`
${STYLES.VerticalLeftAlign};
   padding-bottom: 20px;
    width: 100%;
    height: 100%;
    overflow-x:scroll;
    &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;
